const moment = require('moment')
const weatherIcons = require('./weatherAtlasIcons')

export const openweatherIcon = (code, sunrise, sunset) => {
  const prefix = 'wi wi-'
  const time = light(sunrise, sunset)
  let icon = weatherIcons[code].icon
  if (icon === 'sunny' && time === 'night') icon = 'clear'
  if (!(code > 699 && code < 800) && !(code > 899 && code < 1000)) {
    icon = time + '-' + icon
  }
  icon = prefix + icon
  return icon
}

export const openweatherAtlasIcon = (code) => {
  return weatherIcons[code].atlas
}

export const openweatherImage = (code, sunrise, sunset) => {
  if (code) {
    const ncode = parseInt(code)
    let img = '800'
    const time = sunrise && sunset ? light(sunrise, sunset) : 'day'
    if (ncode < 300) img = '200'
    if (ncode < 600) img = '500'
    if (ncode < 700) img = '600'
    if (ncode < 800) img = '700'
    if (ncode === 800 && time === 'day') img = '80D'
    if (ncode === 800 && time === 'night') img = '80N'
    return img
    // const time = light(sunrise, sunset)
    // let prefix = time === 'day' ? 'day d-' : 'night n-'
    // let img = '800'
    // if (code < 300) img = '200'
    // if (code < 600) img = '500'
    // if (code < 700) img = '600'
    // if (code < 800) img = '700'
    // if (code === 800) img = 'CLR'
    // return prefix + img
  } else {
    return '800'
  }
}

export const light = (sunrise, sunset) => {
  let res = 'day'
  if (sunrise && sunset) {
    const timestamp = moment().unix()
    if (timestamp < sunrise || timestamp > sunset) res = 'night'
  }
  return res
}

export const openweatherDay = (ts) => {
  return moment.unix(ts).startOf('day').format()
}

export const openweatherMoment = (ts, format) => {
  const m = moment.unix(ts)
  return format ? m.format(format) : m.format()
}

// accept a timestamp, and returns the percentage of the day
export const tsToPctOfDay = (ts) => {
  const mmt = moment.unix(ts)
  const start = mmt.clone().startOf('day')
  const minutesPassed = mmt.diff(start, 'minutes')
  const pct = 100 * minutesPassed / 1440
  return Math.round(pct)
}
// console.log(tsToPctOfDay(1559108398))
